import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Component from '../components/balance'
import actions from '../actions/balance'

class Container extends React.Component {

  constructor(props) {
    super(props)

    if (props.isLoggedIn === false) {
      props.history.push('/ingresar')
    } else {
      props.fetch()
    }
  }

  render() {
    return <Component {...this.props} />
  }

  static propTypes = {
    fetch: PropTypes.func.isRequired,
  }
}


const mapStateToProps = state => {
  const data = state.ui.balance.balance
  return {
    isFetching: data.get('isFetching'),
    error: data.get('error'),
    isLoggedIn: state.domain.user.token !== '',
    balance: data.get('balance'),
    activity: (data.get('activity') !== null) ? data.get('activity').toArray() : [],
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetch: () => dispatch(actions.fetch()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/balance/containers/balance.js